export default {
  styleOverrides: {
    root: {
      minWidth: '160px',
      padding: '6px 12px',
      lineHeight: '1.75',
      color: 'rgba(0, 0, 0, 0.7)',
      '&.Mui-selected': {
        color: 'rgba(0, 0, 0, 1)',
        opacity: 1,
      },
    },
  },
};
